import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   

  .generated-images-holder-var37 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var37 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }

  .author-row-var37 {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .author-name-var37 {
    font-weight: 700;
    font-size: 34px;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
  }

  .author-name-var37__blue {
    color: #3D5798;
  }

  .author-image-var37 {
    width: 93px;
    height: 93px;
    object-fit: cover;
    margin-right: 22px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .right-text-holder-var37 {
    height: 100%;
    background-color: white;
    padding: 33px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &--reversed {
      order: -1;
    }
  }
  .right-text-var37 {
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.05em;
    line-height: 1.2;
    p {
      display: inline;
    }
  }
  .left-text-var37 {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 33px;
    width: 50%;
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.04em;
    line-height: 1.2;
    font-weight: 700;
    background-color: white;
      -webkit-text-shadow: 2.2px 0 0 #1C2327;
    -moz-text-shadow: 2.2px 0 0 #1C2327;
    -ms-text-shadow: 2.2px 0 0 #1C2327;
    -o-text-shadow: 2.2px 0 0 #1C2327;
    text-shadow: 2.2px 0 0 #1C2327;
    p {
      display: inline;
    }
  }
  .break-var37 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
`;

export default VariationsStyles;
